module.exports = __webpack_public_path__ + "onboarding-workers.0ea247f5fc40b5c2ed4aa084991d3a22.hashedasset.svg";